import { useQuery } from "@tanstack/react-query";
import {
	getBilletsBetweenCobblesData,
	getBilletsBetweenCobblesPickers,
	type GetBilletsBetweenCobblesParams,
	type GetBilletsBetweenCobblesPickersParams,
} from "../repositories/BilletsBetweenCobblesRepository";

type UseBilletsBetweenCobblesDataParams = Omit<
	GetBilletsBetweenCobblesParams,
	"signal"
>;

export const useBilletsBetweenCobblesData = ({
	start,
	end,
	crewId = null,
	productTypeId = null,
	reportType = 1,
	sortType = null,
}: UseBilletsBetweenCobblesDataParams) => {
	return useQuery({
		queryKey: [
			"billetsBetweenCobblesData",
			start,
			end,
			crewId,
			productTypeId,
			reportType,
			sortType,
		],
		queryFn: ({ signal }) =>
			getBilletsBetweenCobblesData({
				start,
				end,
				crewId,
				productTypeId,
				reportType,
				sortType,
				signal,
			}),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};

type UseBilletsBetweenCobblesPickersParams = Omit<
	GetBilletsBetweenCobblesPickersParams,
	"signal"
>;

export const useBilletsBetweenCobblesPickers = ({
	start,
	end,
}: UseBilletsBetweenCobblesPickersParams) => {
	return useQuery({
		queryKey: ["billetsBetweenCobblesPickers", start, end],
		queryFn: ({ signal }) =>
			getBilletsBetweenCobblesPickers({
				start,
				end,
				signal,
			}),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
